"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filter = void 0;

var filter = function filter(target, condition) {
  var cond = typeof condition === 'function' ? condition(target) : condition;

  if (Array.isArray(target)) {
    return cond ? target : [];
  } else if (typeof target === 'object') {
    return cond ? target : {};
  } else {
    return cond ? target : undefined;
  }
};

exports.filter = filter;